import type { RouteRecordRaw } from 'vue-router';

export const viewsRoutes: RouteRecordRaw[] = [
  {
    path: '/views',
    name: 'ViewsList',
    component: () => import('@/pages/views/CustomViewsListPage.vue'),
  },
  {
    path: '/views/:viewId',
    name: 'ViewResults',
    component: () => import('@/pages/views/CustomViewResultsPage.vue'),
  },
  {
    path: '/managed-views/:viewId',
    name: 'ManagedViewResults',
    component: () => import('@/pages/views/CustomViewResultsPage.vue'),
  },
];
